import { formatOccupantsShort } from 'lib/offer/occupancyUtils'
import type { DrawerHotel } from '../../components/HotelListingDrawer/types'
import { compactLines } from './message'

const MAX_HOTEL_SEARCH_RESULTS_IN_CONTEXT = 3

interface BuildHotelSearchDrawerContextArgs {
  isLoading: boolean
  hasHotels: boolean
  searchLocation: string
  occupancies: Array<App.Occupants>
  savedDrawerHotels: Array<DrawerHotel>
  orderedHotelsWithTileDetails: Array<DrawerHotel>
  checkIn?: string
  checkOut?: string
}

function formatHotelSearchResult(hotel: DrawerHotel, index: number): string {
  const price = hotel.price?.currency
    ? `, ${hotel.price.currency} ${hotel.price.total} for ${hotel.price.nights} night${hotel.price.nights !== 1 ? 's' : ''}`
    : ''
  const location = hotel.location ? `, ${hotel.location}` : ''
  return `Result ${index + 1}: ${hotel.name}${location}${price}`
}

function formatHotelSearchRooms(rooms: Array<App.Occupants>): string {
  return rooms
    .map((room, index) => `Room ${index + 1}: ${formatOccupantsShort(room)}`)
    .join('; ')
}

export function buildHotelSearchDrawerContext({
  isLoading,
  hasHotels,
  searchLocation,
  checkIn,
  checkOut,
  occupancies,
  savedDrawerHotels,
  orderedHotelsWithTileDetails,
}: BuildHotelSearchDrawerContextArgs): string {
  return compactLines([
    'Drawer: Hotel search',
    `Status: ${isLoading ? 'searching' : hasHotels ? 'searched' : 'no results'}`,
    `Destination: ${searchLocation}`,
    checkIn && `Check-in: ${checkIn}`,
    checkOut && `Check-out: ${checkOut}`,
    `Guests: ${formatHotelSearchRooms(occupancies)}`,
    `Saved results: ${savedDrawerHotels.length}`,
    `Explore results visible: ${orderedHotelsWithTileDetails.length}`,
    orderedHotelsWithTileDetails.length > 0 && 'Top visible results:',
    ...orderedHotelsWithTileDetails
      .slice(0, MAX_HOTEL_SEARCH_RESULTS_IN_CONTEXT)
      .map(formatHotelSearchResult),
  ])
}
